<!-- <template>
    <div class="d-content">
        Settings View
    </div>
</template> -->

<template>
    <div class="d-content">
        <dashboard-content-nav :nav="navItems" />
        <keep-alive>
            <component :is="currentComponent" :entity_index="entity_index"></component>
        </keep-alive>
    </div>
</template>
<script>

    import dashboardContentNav from "@/components/dashboard/contentNav.vue";
    import utilities from "./utilities/utilities.vue";


    const mapNameToComponents = {
        utilities: utilities,
        professional_tax: () => import("./utilities/professionalTax/professionalTax.vue"),
        offers: () => import("./offers.vue"),
        orgDetails: () => import("./organisationDetails.vue"),
        employees: () => import("./employees.vue"),
        documents: () => import("./documents.vue")
    };

    const getPathForStep = (entity_index,step_name, sub_step) => {
        if (sub_step) {
            return `/dashboard/${entity_index}/settings/${step_name}/${sub_step}`
        }
        else {
            return `/dashboard/${entity_index}/settings/${step_name}`
        }
    };

    const nav_items = (entity_index) => ([
        // {
        //     type: "navitem",
        //     label: "Org Settings",
        //     path: getPathForStep('orgDetails'),
        //     icon: "organisation",
        // },
        // {
        //     type: "navitem",
        //     label: "Legacy Data",
        //     path: getPathForStep('orgDetails'),
        //     icon: "organisation",
        // },{
        //     type: "navitem",
        //     label: "Map Policies Against Grades",
        //     path: getPathForStep('orgDetails'),
        //     icon: "organisation",
        // },
        {
            type: "navitem",
            label: "Organisation Details",
            path: getPathForStep(entity_index,'orgDetails'),
            icon: "organisation",
        },
        {
            type: "navitem",
            label: "Employees",
            path: getPathForStep(entity_index,'employees'),
            icon: "organisation",
            children: [
                {
                    path: getPathForStep(entity_index,'employees', 'addEmployee')
                }
            ]
        },
        {
            type: "navitem",
            label: "Documents",
            path: getPathForStep(entity_index,'documents'),
            icon: "organisation"
        },
        {
            type: "navitem",
            label: "Offers",
            path: getPathForStep(entity_index,'offers'),
            icon: "reports"
        },
        {
            type: "navitem",
            label: "Utilities",
            path: getPathForStep(entity_index,'utilities'),
            icon: "settings-1",
            children: [
                {
                    path: getPathForStep(entity_index,'utilities', 'professional_tax'),
                }
            ]
        }
    ]);

    export default {
        components: {
            dashboardContentNav
        },
        props: ['step_name', 'sub_step', 'sub_step_name','entity_index'],
        data() {
            return {
                navItems: []
            }
        },
        methods: {
            contentShow(event) {
                var sections = document.querySelectorAll(".d-payroll__accordBlock");
                for (let i = 0; i < sections.length; i++) {
                    sections[i].classList.remove("active");
                }
                event.target.parentNode.classList.toggle("active");
            }
        },
        created() {
            this.navItems = nav_items(this.entity_index);
        },
        computed: {
            currentComponent: function () {
                if (this.sub_step_name) {
                    return mapNameToComponents[this.sub_step_name];
                } else {
                    return mapNameToComponents[this.sub_step];
                }
            }
        }
    };
</script>
<style lang="scss" scoped>
    @import "@/scss/dashboard/_variables.scss"; // Common
    @import "@/scss/dashboard/content/_section.scss"; // Content Section
</style>
